import React from 'react';
import Donut from '~components/Donut';
import styles from './styles.module.css';

type Props = {
  area: {
    totalKitchen: number;
    totalOffices: number;
    totalOpenSpace: number;
    totalMeetingRooms: number;
  };
  total: number;
  children: React.ReactNode;
};

const Chart = ({ area, total, children }: Props) => (
  <div>
    <div className={styles['chart__caption']}>
      <h2>Рекомендуемая площадь</h2>
      <div className={styles['chart__total']}>
        ~ {total} м<sup>2</sup>
      </div>
    </div>
    <div className={styles['chart']}>
      <div className={styles['chart__donut']}>
        <Donut area={area} />
      </div>
      <div className={styles['chart__info']}>{children}</div>
    </div>
  </div>
);

export default Chart;
